import { render, staticRenderFns } from "./compareRank.vue?vue&type=template&id=3a74c548&"
import script from "./compareRank.vue?vue&type=script&lang=js&"
export * from "./compareRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports